import { AdminLayout } from '@/components/layouts'
import { ArticleForm } from './ArticleForm'

interface Community {
  id: number
  name: string
}

interface Category {
  id: number
  name: string
  community_id: number
  parent_id: number | null
}

interface NewProps {
  communities: Community[]
  categories: Category[]
}

export default function New({ communities, categories }: NewProps) {
  return (
    <AdminLayout
      title="Nouvel article"
      breadcrumbs={[
        { label: 'Articles', href: '/admin/articles' },
        { label: 'Nouvel article' }
      ]}
    >
      <div className="max-w-4xl">
        <ArticleForm
          communities={communities}
          categories={categories}
          onSubmit="/admin/articles"
        />
      </div>
    </AdminLayout>
  )
}
